import { styled } from "styled-components";
const CardMenuWrapper = styled("div")(
  {
    position: "absolute",
    right: 16
  },
  ({ variant }) => ({
    concealed: {
      backgroundColor: "white",
      borderRadius: 4,
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
      padding: 4,
      top: 16
    },
    standard: {
      top: "50%",
      transform: "translateY(-50%)"
    }
  })[variant]
);
export {
  CardMenuWrapper
};
